module.exports = __webpack_public_path__ + "pic/23.1818771b.png";